import React from 'react'

export default function EpicsPage() {
  return (
    <div>EpicsPage</div>
  )
}
